import BankIdVerification from '../ui/bank-id-verification';
import bootLayout from 'tradera/legacy/static/app/boot/boot-layout';

export default function (initData) {
    bootLayout(initData);
    BankIdVerification.attachTo('[data-account-locked-verify-bankId]');
}
